import React, { useEffect, useState } from "react";
import Registration from "./Registration"
import { useDispatch, useSelector } from "react-redux";
import { clearAll, setAadhaar, setCustomer, setDl, setPassport, setPerAddress, setPhone1, setPhone2, setPhone3, setSecAadhaar, setSecDetails, setSecDl, setSecPassport, setStep, setTempAddress } from "../../../Reducer/customerSlice"
import Verification from "./Verification";
import Address from "./Address";
import DL from "./DL";
import Passport from "./Passport";
import White from "../../../Assets/images/white-bg.avif"
import KYC from "./KYC";
import Other from "./Other";
import Photo from "./Photo";
import Modal from "../../../Helpers/Components/Modal";
import Handler from "../../../Helpers/Components/Handler";
import { toast } from "react-toastify";
import { reloadWindowToPath, parseDob } from "../../../Helpers/Utils";
import moment from "moment";
import Aadhaar from "./Aadhaar";
import { useNavigate, useParams } from "react-router-dom";
import { FaMinus, FaPlus } from "react-icons/fa";

const Register = () => {
    const { id } = useParams()
    const { bookingId } = useParams()
    const { steps } = useParams()
    const [customerId, setCustomerId] = useState("")
    const step = useSelector((state) => state.customer?.step);
    const customer = useSelector((state) => state.customer?.customer);
    const phone1 = useSelector((state) => state.customer?.phone1);
    const phone2 = useSelector((state) => state.customer?.phone2);
    const phone3 = useSelector((state) => state.customer?.phone3);
    const navigate = useNavigate()
    const dl = useSelector((state) => state.customer?.dl);
    const secDl = useSelector((state) => state.customer?.secDl);
    const aadhaar = useSelector((state) => state.customer?.aadhaar);
    const secAadhaar = useSelector((state) => state.customer?.secAadhaar);
    const passport = useSelector((state) => state.customer?.passport);
    const secPassport = useSelector((state) => state.customer?.secPassport);
    const tempAddress = useSelector((state) => state.customer?.tempAddress);
    const [preview, setPreview] = useState(false)
    const dispatch = useDispatch()
    const [zoom, setZoom] = useState(1);
    const [page, setPage] = useState({ kyc: false, other: false })
    const [loading, setLoading] = useState(false)
    const [other, setOther] = useState([])
    const [proof, setProof] = useState(false)
    const [chosen, setChosen] = useState("")
    const handleSubmit = async () => {
        setLoading(true)
        toast.success("Customer Registered Successfully")
        setTimeout(() => {
            if (bookingId) {
                reloadWindowToPath(`/booking/delivery/${bookingId}`)
            } else {
                reloadWindowToPath("/customer/1")
            }
        }, 1500);
    }
    const formatValidTo = (validTo) => {
        if (!validTo) return "";
        // const parts = validTo.split("/");
        // if (parts.length !== 3) return "";
        // const [day, month, year] = parts;
        // const date = moment(`${year}-${month}-${day}`, "YYYY-MM-DD", true);
        // return date.isValid() ? date.format("DD-MM-YYYY") : "";
        const date = moment(validTo, ["DD/MM/YYYY", "DD-MM-YYYY"], true);
        return date.isValid() ? date.format("DD-MM-YYYY") : "";
    };
    const getDetails = async () => {
        setLoading(true)
        const response = await Handler({ method: "get", url: `/customer/details/view/${id}` });
        setLoading(false)
        if (response?.success) {
            const data = response?.data
            const other = data?.otherKyc?.length ? data?.otherKyc?.filter((element) => element?.type !== "dl" && element?.type !== "aadhaar" && element?.type !== "passport") : []
            const check = other?.length ? other[0]?.photo?.length ? other[0]?.photo?.filter(element => element) : [] : []
            setOther(check?.length ? check?.map(element => { return { url: element, file: element } }) : [])
            dispatch(setTempAddress({ ...data?.tempAddress, state: data?.tempAddress?.state?.toUpperCase(), country: data?.tempAddress?.country?.toUpperCase() }))
            dispatch(setPerAddress({ ...data?.perAddress, state: data?.perAddress?.state?.toUpperCase(), country: data?.perAddress?.country?.toUpperCase() }))
            dispatch(setCustomer({ ...data, documentId: other?.length ? other[0]?.id : "", documentType: other?.length ? other[0]?.type : "", email: data?.email?.emailId, emailStatus: data?.email?.status, profile: data?.photo || "" }))
            let phone1 = data?.phone?.length ? data?.phone?.filter((element) => element?.priority === 1)?.length ? data?.phone?.filter((element) => element?.priority === 1)[0] : "" : ""
            let phone2 = data?.phone?.length ? data?.phone?.filter((element) => element?.priority === 2)?.length ? data?.phone?.filter((element) => element?.priority === 2)[0] : "" : ""
            let phone3 = data?.phone?.length ? data?.phone?.filter((element) => element?.priority === 3)?.length ? data?.phone?.filter((element) => element?.priority === 3)[0] : "" : ""
            dispatch(setPhone1({ phone: phone1?.phone, priority: 1, both: phone1?.both || false, type: phone1?.type, code: phone1?.code, status: phone1?.status, otp: '', otpSent: false, disable: false, load: false }))
            dispatch(setPhone2({ phone: phone2?.phone, code: phone2?.code, both: phone2?.both || false, priority: 2, type: phone2?.type, status: phone2?.status, otp: '', load: false, otpSent: false, disable: false }))
            dispatch(setPhone3({ phone: phone3?.phone, code: phone3?.code, both: phone3?.both || false, priority: 3, type: phone3?.type, status: phone3?.status, otp: '', load: false, otpSent: false, disable: false }))
            let dl = data?.kyc?.length ? (data?.kyc?.filter(element => element?.type === "dl")?.length ? data?.kyc?.filter(element => element?.type === "dl")[0] : {}) : {}
            let aadhaar = data?.kyc?.length ? (data?.kyc?.filter(element => element?.type === "aadhaar")?.length ? data?.kyc?.filter(element => element?.type === "aadhaar")[0] : {}) : {}
            let passport = data?.kyc?.length ? (data?.kyc?.filter(element => element?.type === "passport")?.length ? data?.kyc?.filter(element => element?.type === "passport")[0] : {}) : {}
            const dlDob = parseDob(dl?.detail?.dateOfBirth || dl?.detail?.dob)?.toString() || ""
            const validUpto = dl?.detail?.validTo || "";
            const [day, month, year] = validUpto ? validUpto?.split("/") : [0, 0, 0];
            const validDate = validUpto ? new Date(Number(year), Number(month) - 1, Number(day)) : null;
            dispatch(setSecDetails(response.data?.secDetails))
            dispatch(setDl({
                dob: dlDob && dlDob !== "Invalid Date" ? dlDob : "",
                dl: dl?.id || "",
                dlDate: validDate && !isNaN(validDate?.getTime()) ? validDate : "",
                dlStatus: dl?.status,
                dl_back_photo: dl?.photo?.length >= 2 ? dl?.photo[1] : "", dl_photo: dl?.photo?.length >= 1 ? dl?.photo[0] : "",
                dlPhoto: dl?.photo?.length >= 1 ? dl?.photo[0] : "",
                dlBackPhoto: dl?.photo?.length >= 2 ? dl?.photo[1] : "",
                detail: dl?.detail
            }))
            dispatch(setAadhaar({ aadhaar: aadhaar?.id || "", decentroId: "", phoneNo: "", reference_id: false, aadhaar_back_photo: aadhaar?.photo?.length >= 2 ? aadhaar?.photo[1] : "", aadhaar_photo: aadhaar?.photo?.length >= 1 ? aadhaar?.photo[0] : "", aadhaarPhoto: aadhaar?.photo?.length >= 1 ? aadhaar?.photo[0] : "", aadhaarBackPhoto: aadhaar?.photo?.length >= 2 ? aadhaar?.photo[1] : "", otp: "", aadhaarStatus: aadhaar?.status, otpSent: false, disable: false }))
            dispatch(setPassport({
                passport: passport?.id || "",
                passportDate: passport?.detail?.passportDate ? new Date(passport?.detail?.passportDate?.split("-")[1] + "/" + passport?.detail?.passportDate?.split("-")[0] + "/" + passport?.detail?.passportDate?.split("-")[2])?.toString() : "",
                passportName: passport?.detail?.passportName || "", passportStatus: passport?.status || false, passport_photo_1: passport?.photo?.length >= 2 ? passport?.photo[1] : "", passport_photo: passport?.photo?.length >= 1 ? passport?.photo[0] : "", passportPhoto: passport?.photo?.length >= 1 ? passport?.photo[0] : "", passportPhoto1: passport?.photo?.length >= 2 ? passport?.photo[1] : "", passport_photo_2: passport?.photo?.length >= 3 ? passport?.photo[2] : "", passportPhoto2: passport?.photo?.length >= 3 ? passport?.photo[2] : ""
            }))







            let secDl = data?.otherKyc?.length ? (data?.otherKyc?.filter(element => element?.type === "dl")?.length ? data?.otherKyc?.filter(element => element?.type === "dl")[0] : {}) : {}
            let secAadhaar = data?.otherKyc?.length ? (data?.otherKyc?.filter(element => element?.type === "aadhaar")?.length ? data?.otherKyc?.filter(element => element?.type === "aadhaar")[0] : {}) : {}
            let secPassport = data?.otherKyc?.length ? (data?.otherKyc?.filter(element => element?.type === "passport")?.length ? data?.otherKyc?.filter(element => element?.type === "passport")[0] : {}) : {}
            const secDlDob = parseDob(secDl?.detail?.dob || secDl?.detail?.dateOfBirth)?.toString() || ""
            const validTo = secDl?.detail?.validTo || "";
            const [day1, month1, year1] = validTo ? validTo?.split("/") : [0, 0, 0];
            const validDate1 = validTo ? new Date(Number(year1), Number(month1) - 1, Number(day1)) : null;
            dispatch(setSecDl({
                detail: secDl?.detail,
                dob: secDlDob ? secDlDob : (response.data?.secDetails?.dob ? response.data?.secDetails?.dob : ""),
                dl: secDl?.id || "",
                dlDate: secDl?.status && secDl?.detail?.validTo ? secDl?.detail?.validTo : (validDate1 && !isNaN(validDate1?.getTime()) ? validDate1 : ""),
                dlStatus: secDl?.status,
                dl_back_photo: secDl?.photo?.length >= 2 ? secDl?.photo[1] : "", dl_photo: secDl?.photo?.length >= 1 ? secDl?.photo[0] : "",
                dlPhoto: secDl?.photo?.length >= 1 ? secDl?.photo[0] : "",
                dlBackPhoto: secDl?.photo?.length >= 2 ? secDl?.photo[1] : ""
            }))
            const checkDob = formatValidTo(secPassport?.detail?.passportDate || secPassport?.detail?.validUpto || "")
            const checkPassDob = secPassport?.detail?.dob ? formatValidTo(secPassport?.detail?.dob) : ""
            dispatch(setSecAadhaar({ aadhaar: secAadhaar?.id || "", decentroId: "", phoneNo: "", reference_id: false, aadhaar_back_photo: secAadhaar?.photo?.length >= 2 ? secAadhaar?.photo[1] : "", aadhaar_photo: secAadhaar?.photo?.length >= 1 ? secAadhaar?.photo[0] : "", aadhaarPhoto: secAadhaar?.photo?.length >= 1 ? secAadhaar?.photo[0] : "", aadhaarBackPhoto: secAadhaar?.photo?.length >= 2 ? secAadhaar?.photo[1] : "", otp: "", aadhaarStatus: secAadhaar?.status, otpSent: false, disable: false }))
            dispatch(setSecPassport({
                dob: secPassport?.status && checkPassDob ? checkPassDob : (response.data?.secDetails?.dob ? response.data?.secDetails?.dob : ""),
                passport: secPassport?.id || "",
                passportDate: secPassport?.status && secPassport?.detail?.passportDate ? secPassport?.detail?.passportDate : (checkDob ? (checkDob?.split("-")[1] + "-" + checkDob?.split("-")[0] + "-" + checkDob?.split("-")[2]) : undefined),
                passportName: secPassport?.detail?.passportName || "",
                passportStatus: secPassport?.status || false, passport_photo_1: secPassport?.photo?.length >= 2 ? secPassport?.photo[1] : "", passport_photo: secPassport?.photo?.length >= 1 ? secPassport?.photo[0] : "", passportPhoto: secPassport?.photo?.length >= 1 ? secPassport?.photo[0] : "", passportPhoto1: secPassport?.photo?.length >= 2 ? secPassport?.photo[1] : "", passport_photo_2: secPassport?.photo?.length >= 3 ? secPassport?.photo[2] : "", passportPhoto2: secPassport?.photo?.length >= 3 ? secPassport?.photo[2] : ""
            }))
            setPage({ other: other?.length ? true : false, kyc: secDl?.type || secAadhaar?.type || secPassport?.type || data?.secPhoto ? true : false })
            if (bookingId) {
                dispatch(setStep(0))
            } else {
                dispatch(setStep(steps ? (steps > 8 ? 0 : Number(steps)) : data?.screen > 8 ? 0 : Number(data?.screen)))
            }
            if (Number(steps) === 6) {
                setPage((prev) => ({ ...prev, kyc: true }))
            }
            if (Number(steps) === 7) {
                setPage((prev) => ({ ...prev, other: true }))
            }
        } else {
            reloadWindowToPath(`/customer/1`)
        }
    }
    const updateSteps = async () => await Handler({ method: 'PATCH', url: `/customer/change/step/${customerId}?step=${step}`, data: {} })
    useEffect(() => {
        if (id) {
            setCustomerId(id);
            getDetails()
        }
    }, [id])
    useEffect(() => {
        dispatch(clearAll())
    }, [])
    useEffect(() => {
        if (customerId) {
            updateSteps()
        }
    }, [step])
    return (
        <React.Fragment>
            <div className="arrow-back"><i onClick={() => navigate(-1)} className="fa-solid fa-arrow-left fs-5 cursor-pointer"></i></div>
            <h5 className="text-center text-theme fs-4">Customer {id ? "Update" : "Register"}</h5>
            <div className="layout-card mt-4">
                <div className="inside-fixed">
                    {
                        id ?
                            <>
                                <div className="row">
                                    <div className="text-center col-sm-4 text-capitalize"><span className="topTitle">Created By : </span>{(customer?.createdBy ? customer?.createdBy : "-")}</div>
                                    <div className="text-center col-sm-4"><span className="topTitle">Cust ID : </span>{(customer?.customerId ? customer?.customerId : "-")}</div>
                                    <div className="text-center col-sm-4"><span className="topTitle">Register Date : </span>{(customer?.createdAt ? moment(customer?.createdAt)?.format("DD/MM/YYYY") : "-")}</div>
                                </div>
                                <hr className="mb-3" />
                            </>
                            : ""
                    }

                </div>
                <div className="row mb-5">
                    <div className="d-flex align-items-center justify-content-lg-center mb-lg-0 mb-2 col-sm-4"><span className="completed-tab round-span me-2"></span> Verified / Completed</div>
                    <div className="d-flex align-items-center justify-content-lg-center  mb-lg-0 mb-2 col-sm-4"><span className="filled-tab round-span me-2"></span>Filled Not Verified</div>
                    <div className="d-flex align-items-center justify-content-lg-center  mb-lg-0 mb-2 col-sm-4"><span className="round-span me-2"></span>Not Filled</div>
                </div>
                <div className="row">
                    <div className="col-lg-3 d-lg-block d-flex justify-content-between mb-lg-0 mb-4 tab-col">
                        <div className="d-flex align-items-center gap-2">
                            <span className={`${step === 0 ? "active-tab" :
                                (step > 0 && customer?.firstName ? "completed-tab" : "")
                                } round-span`}>{step > 0 && customer?.firstName ? <i className="fa-solid fa-check"></i> : "1"}</span>
                            <div className={`register-tabs d-lg-block d-none`}>Registration</div>
                        </div>
                        <div className="d-flex align-items-center gap-2 my-lg-4 my-0">
                            <span className={`${step === 1 ? "active-tab" :
                                (customer?.phone?.length ? customer?.phone?.filter(element => element?.status)?.length >= (customer?.custType === "local" ? 3 : 2) ? "completed-tab" : "" : "")
                                } round-span`}>
                                {customer?.phone?.length ? customer?.phone?.filter(element => element?.status)?.length >= (customer?.custType === "local" ? 3 : 2) && step !== 1 ? <i className="fa-solid fa-check"></i> : "2" : "2"}
                            </span>
                            <div className="register-tabs d-lg-block d-none">Verification</div>
                        </div>
                        <div className="d-flex align-items-center gap-2  my-lg-4 my-0">
                            <span className={`${step === 2 ? "active-tab" :
                                (customer?.tempAddress?.line1 ? "completed-tab" : "")
                                } round-span`}>
                                {customer?.tempAddress?.line1 && step !== 2 ? <i className="fa-solid fa-check"></i> : "3"}</span>
                            <div className="register-tabs d-lg-block d-none">Address</div>
                        </div>
                        <div className="d-flex align-items-center gap-2  my-lg-4 my-0">
                            <span className={`${step === 3 ? "active-tab" :
                                (customer?.kyc?.length ? customer?.kyc?.filter(element => element?.type === "dl")?.length ? (customer?.kyc?.filter(element => element?.type === "dl")[0]?.status ? "completed-tab" : "filled-tab") : "" : "")
                                } round-span`}>
                                {step !== 3 && customer?.kyc?.length ? customer?.kyc?.filter(element => element?.type === "dl")?.length ? (customer?.kyc?.filter(element => element?.type === "dl")[0]?.status ? <i className="fa-solid fa-check"></i> : "4") : "4" : "4"}
                            </span>
                            <div className="register-tabs d-lg-block d-none">DL</div>
                        </div>
                        <div className="d-flex align-items-center gap-2  my-lg-4 my-0">
                            <span className={`${step === 4 ? "active-tab" :
                                (customer?.kyc?.length ? customer?.kyc?.filter(element => element?.type === "aadhaar")?.length ? (customer?.kyc?.filter(element => element?.type === "aadhaar")[0]?.status ? "completed-tab" : "filled-tab") : "" : "")
                                } round-span`}>
                                {step !== 4 && customer?.kyc?.length ? customer?.kyc?.filter(element => element?.type === "aadhaar")?.length ? (customer?.kyc?.filter(element => element?.type === "aadhaar")[0]?.status ? <i className="fa-solid fa-check"></i> : "5") : "5" : "5"}
                            </span>
                            <div className="register-tabs d-lg-block d-none">Aadhaar</div>
                        </div>
                        <div className="d-flex align-items-center gap-2  my-lg-4 my-0">
                            <span className={`${step === 5 ? "active-tab" :
                                (customer?.kyc?.length ? customer?.kyc?.filter(element => element?.type === "passport")?.length ? (customer?.kyc?.filter(element => element?.type === "passport")[0]?.status ? "completed-tab" : "filled-tab") : "" : "")
                                } round-span`}>
                                {step !== 5 && customer?.kyc?.length ? customer?.kyc?.filter(element => element?.type === "passport")?.length ? (customer?.kyc?.filter(element => element?.type === "passport")[0]?.status ? <i className="fa-solid fa-check"></i> : "6") : "6" : "6"}
                            </span>
                            <div className="register-tabs d-lg-block d-none">Passport</div>
                        </div>
                        <div className="d-flex align-items-center gap-2  my-lg-4 my-0">
                            <span className={`${step === 6 ? "active-tab" :
                                (customer?.otherKyc?.length ? customer?.otherKyc?.filter(element => element?.type === "passport" || element?.type === "dl" || element?.type === "aadhaar")?.length ? (customer?.otherKyc?.filter(element => (element?.type === "passport" || element?.type === "dl" || element?.type === "aadhaar") && element?.status)?.length ? "completed-tab" : "filled-tab") : "" : "")
                                } round-span`}>
                                {step !== 6 && customer?.otherKyc?.length ? customer?.otherKyc?.filter(element => element?.type === "passport" || element?.type === "dl" || element?.type === "aadhaar")?.length ? (customer?.otherKyc?.filter(element => (element?.type === "passport" || element?.type === "dl" || element?.type === "aadhaar") && element?.status) ? <i className="fa-solid fa-check"></i> : "7") : "7" : "7"}
                            </span>
                            <div className="register-tabs d-lg-block d-none">Sec Cust KYC</div>
                        </div>
                        <div className="d-flex align-items-center gap-2  my-lg-4 my-0">
                            <span className={`${step === 7 ? "active-tab" :
                                (customer?.otherKyc?.length && customer?.otherKyc?.filter(element => element?.type !== "dl" && element?.type !== "aadhaar" && element?.type !== "passport")?.length ? "completed-tab" : "")
                                } round-span`}>
                                {step !== 7 && customer?.otherKyc?.length && customer?.otherKyc?.filter(element => element?.type !== "dl" && element?.type !== "aadhaar" && element?.type !== "passport")?.length ? <i className="fa-solid fa-check"></i> : "8"}
                            </span>
                            <div className="register-tabs d-lg-block d-none">Other Document</div>
                        </div>
                        <div className="d-flex align-items-center gap-2  my-lg-4 my-0">
                            <span className={`${step === 8 ? "active-tab" :
                                (customer?.photo ? "completed-tab" : "")
                                } round-span`}>{step !== 8 && customer?.photo ? <i className="fa-solid fa-check"></i> : "9"}</span>
                            <div className="register-tabs d-lg-block d-none">Photo</div>
                        </div>
                    </div>
                    <div className="col-lg-9">
                        {
                            step === 0 ?
                                <Registration setCustomerId={setCustomerId} customerId={customerId} />
                                :
                                step === 1 ?
                                    <Verification customerId={customerId} />
                                    :
                                    step === 2 ?
                                        <Address customerId={customerId} />
                                        :
                                        step === 3 ?
                                            <DL customerId={customerId} setProof={setProof} setChosen={setChosen} />
                                            :
                                            step === 4 ?
                                                <Aadhaar customerId={customerId} setProof={setProof} setChosen={setChosen} />
                                                : step === 5 ?
                                                    <Passport customerId={customerId} setProof={setProof} setChosen={setChosen} page={page} setPage={setPage} />
                                                    :
                                                    step === 6 && page?.kyc ?
                                                        <KYC customerId={customerId} setProof={setProof} setChosen={setChosen} page={page} setPage={setPage} />
                                                        : step === 7 && page?.other ?
                                                            <Other customerId={customerId} setProof={setProof} page={page} setChosen={setChosen} other={other} setOther={setOther} />
                                                            :
                                                            step === 8 ?
                                                                <Photo page={page} customerId={customerId} setPreview={setPreview} setProof={setProof} setChosen={setChosen} />
                                                                :
                                                                (customerId ? <Photo page={page} customerId={customerId} setPreview={setPreview} setProof={setProof} setChosen={setChosen} /> : <Registration setCustomerId={setCustomerId} customerId={customerId} />)
                        }
                    </div>
                </div>
            </div>
            <Modal header="Preview" size={'lg'} onShow={preview} footerClassname={'justify-content-center'} toggle={() => setPreview(false)} overlayToggle={() => setPreview(false)}>
                <div className="row justify-content-center mb-3">
                    <div className="col-lg-7">
                        <div className="card p-3 d-flex flex-column align-items-center justify-content-center text-capitalize">
                            <h6 className="text-center mb-3">Profile Details</h6>
                            <div className="profile"><img src={customer?.profile || White} alt="Profile" /></div>
                            <div className="fw-bold mt-3">{customer?.firstName + " " + customer?.lastName}</div>
                            {phone1?.phone ? <div>{(phone1?.code || "") + "-" + (phone1?.phone || "")}</div> : ""}
                            {phone2?.phone ? <div>{(phone2?.code || "") + "-" + (phone2?.phone || "")}</div> : ""}
                            {phone3?.phone ? <div>{(phone3?.code || "") + "-" + (phone3?.phone || "")}</div> : ""}
                            <div className="">{customer?.email || ""}</div>
                            <div className="">{customer?.dob ? moment(new Date(customer?.dob))?.utcOffset("+05:30")?.format("DD-MM-YYYY") : ""}</div>
                            <div className="text-center">{tempAddress?.line1 ? (tempAddress?.line1 + ", " + tempAddress?.line2 + ", " + tempAddress?.area + ", " + (tempAddress?.state || "Tamilnadu") + ", " + (tempAddress?.country || "India") + ", " + tempAddress?.pincode) : ""}</div>
                        </div>
                    </div>
                </div>
                <div className="row align-items-stretch">
                    {
                        dl?.dl ?
                            <div className="col-lg-6 mb-3">
                                <div className="card h-100 p-3 text-capitalize">
                                    <h6>DL Details</h6>
                                    <div className="row">
                                        <label htmlFor="dlNo" className="col-4 col-form-label fw-medium">DL No</label>
                                        <div className="col-8">
                                            <label type="text" readOnly className="form-control-plaintext" id="dlNo">{dl?.dl || "-"}</label>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <label htmlFor="dlDate" className="col-4 col-form-label fw-medium">Valid Upto</label>
                                        <div className="col-8">
                                            <label type="text" readOnly className="form-control-plaintext" id="dlDate" > {dl?.dlDate ? moment(new Date(dl?.dlDate))?.format("DD/MM/YYYY") : "-"}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            : ""
                    }
                    {
                        aadhaar?.aadhaar
                            ? <div className="col-lg-6 mb-3">

                                <div className="card h-100 p-3 text-capitalize">
                                    <h6>Aadhaar Details</h6>
                                    <div className="row">
                                        <label htmlFor="aadhaar" className="col-4 col-form-label fw-medium">Aadhaar No</label>
                                        <div className="col-8">
                                            <label type="text" readOnly className="form-control-plaintext" id="aadhaar">{aadhaar?.aadhaar || "-"}</label>
                                        </div>
                                    </div>
                                </div>

                            </div> : ""
                    }
                    {
                        passport?.passport
                            ? <div className="col-lg-6 mb-3">

                                <div className="card h-100 p-3 text-capitalize">
                                    <h6>Passport Details</h6>
                                    <div className="row">
                                        <label htmlFor="passport" className="col-4 col-form-label fw-medium">Passport No</label>
                                        <div className="col-8">
                                            <label type="text" readOnly className="form-control-plaintext" id="passport">{passport?.passport || "-"}</label>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <label htmlFor="passportName" className="col-4 col-form-label fw-medium">Name</label>
                                        <div className="col-8">
                                            <label type="text" readOnly className="form-control-plaintext" id="passportName">{passport?.passportName || "-"}</label>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <label htmlFor="passportDate" className="col-4 col-form-label fw-medium">Valid Upto</label>
                                        <div className="col-8">
                                            <label type="text" readOnly className="form-control-plaintext" id="passportDate" > {passport?.passportDate ? moment(new Date(passport?.passportDate))?.format("DD/MM/YYYY") : "-"}</label>
                                        </div>
                                    </div>
                                </div>

                            </div> : ""
                    }
                    {
                        customer?.documentId
                            ? <div className="col-lg-6 mb-3">

                                <div className="card h-100 p-3">
                                    <h6>Other Proof</h6>
                                    <div className="row">
                                        <label htmlFor="documentType" className="col-4 col-form-label fw-medium">Doc Type</label>
                                        <div className="col-8">
                                            <label type="text" readOnly className="form-control-plaintext" id="documentType">{customer?.documentType || "-"}</label>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <label htmlFor="documentId" className="col-4 col-form-label fw-medium">Doc ID</label>
                                        <div className="col-8">
                                            <label type="text" readOnly className="form-control-plaintext" id="documentId">{customer?.documentId || "-"}</label>
                                        </div>
                                    </div>
                                </div>

                            </div> : ""
                    }
                    {
                        secDl?.dl ? <div className="col-lg-6 mb-3">

                            <div className="card h-100 p-3">
                                <h6>Sec Cust DL Details</h6>
                                <div className="row">
                                    <label htmlFor="dlNo" className="col-4 col-form-label fw-medium">DL No</label>
                                    <div className="col-8">
                                        <label type="text" readOnly className="form-control-plaintext" id="dlNo">{secDl?.dl || "-"}</label>
                                    </div>
                                </div>
                                <div className="row">
                                    <label htmlFor="dlDate" className="col-4 col-form-label fw-medium">Valid Upto</label>
                                    <div className="col-8">
                                        <label type="text" readOnly className="form-control-plaintext" id="dlDate" > {secDl?.dlDate ? moment(new Date(secDl?.dlDate))?.format("DD/MM/YYYY") : "-"}</label>
                                    </div>
                                </div>
                            </div>

                        </div> : ""
                    }
                    {
                        secAadhaar?.aadhaar
                            ? <div className="col-lg-6 mb-3">

                                <div className="card h-100 p-3">
                                    <h6>Sec Cust Aadhaar Details</h6>
                                    <div className="row">
                                        <label htmlFor="aadhaar" className="col-4 col-form-label fw-medium">Aadhaar No</label>
                                        <div className="col-8">
                                            <label type="text" readOnly className="form-control-plaintext" id="aadhaar">{secAadhaar?.aadhaar || "-"}</label>
                                        </div>
                                    </div>
                                </div>

                            </div> : ""
                    }
                    {
                        secPassport?.passport
                            ? <div className="col-lg-6 mb-3">

                                <div className="card h-100 p-3">
                                    <h6>Sec Cust Passport Details</h6>
                                    <div className="row">
                                        <label htmlFor="passport" className="col-4 col-form-label fw-medium">Passport No</label>
                                        <div className="col-8">
                                            <label type="text" readOnly className="form-control-plaintext" id="passport">{secPassport?.passport || "-"}</label>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <label htmlFor="passportName" className="col-4 col-form-label fw-medium">Name</label>
                                        <div className="col-8">
                                            <label type="text" readOnly className="form-control-plaintext" id="passportName">{secPassport?.passportName || "-"}</label>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <label htmlFor="passportDate" className="col-4 col-form-label fw-medium">Valid Upto</label>
                                        <div className="col-8">
                                            <label type="text" readOnly className="form-control-plaintext" id="passportDate" > {secPassport?.passportDate ? moment(new Date(secPassport?.passportDate))?.format("DD/MM/YYYY") : "-"}</label>
                                        </div>
                                    </div>
                                </div>

                            </div> : ""
                    }
                </div>
                <div className="pt-4 pb-2 text-center">
                    <button className="btn btn-success" disabled={loading} onClick={handleSubmit}>{loading ? <i className="fa-solid fa-spinner fa-spin"></i> : "Submit"}</button>
                </div>
            </Modal>
            <Modal header="Photo" draggable={true} onShow={proof} toggle={() => setProof(false)} overlayToggle={() => setProof(false)}>
                <div>
                    <div className="modalPhoto">
                        <img src={chosen || White} alt="Proof" style={{ transform: `scale(${zoom})`, transformOrigin: "top left", transition: "transform 0.2s", }} />
                    </div>
                    <div className="d-flex gap-3 mb-2 mt-3 justify-content-center align-items-center">
                        <button className="btn maximize-button p-0" onClick={() => setZoom((prev) => prev + 0.1)}><FaPlus /></button>
                        <button className="btn maximize-button p-0" onClick={() => setZoom((prev) => Math.max(0.1, prev - 0.1))}> <FaMinus /> </button>
                    </div>
                    <div className="text-center"> <button className="btn border-0 btn-sm btn-danger" onClick={() => setZoom(1)}>Reset</button></div>
                </div>
            </Modal>

        </React.Fragment>
    )
}

export default Register